import { render } from "./labTestVersion.vue?vue&type=template&id=e639f97c"
import script from "./labTestVersion.js?vue&type=script&lang=js"
export * from "./labTestVersion.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__